import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetSportCategories, SearchActivities,SearchFoodPreferences } from "../../../fakebackend_helper";

// Action pour récupérer les catégories d'exercice
export const fetchExerciseCategories = createAsyncThunk(
  "exerciseCategories/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetSportCategories();
      return response.data.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Action pour rechercher des activités par mot-clé
export const FetchActivitiesByKeyword = createAsyncThunk(
  'activity/searchActivities',
  async (keyword, { rejectWithValue }) => {
    try {
      const response = await SearchActivities(keyword);
      console.log("search activity modal", response.data)
      return response.data; // <- ici, on accède à `data`
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la recherche des activités');
    }
  }
);
// Dans votre fichier d'actions (ex: actions/foodPreferencesActions.js)
export const FetchFoodPreferencesByKeyword = createAsyncThunk(
  'foodPreferences/searchPreferences',
  async (keyword, { rejectWithValue }) => {
    try {
      const response = await SearchFoodPreferences(keyword);
      return response.data.data; // Adaptez selon la structure de votre réponse
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la recherche des préférences alimentaires');
    }
  }
);
